import { Link } from 'react-router-dom'
import { Github, MessageCircle, Twitter } from 'lucide-react'

export default function Footer() {
	return (
		<footer className="bg-vscode-sidebar border-t border-vscode-border">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
				<div className="grid grid-cols-1 md:grid-cols-4 gap-8">
					{/* Brand */}
					<div className="space-y-4">
						<div className="flex items-center space-x-3">
							<img src="/logo-dark.svg" alt="SakaDev" className="w-8 h-8" />
							<span className="text-xl font-semibold text-vscode-text-bright font-sans">SakaDev</span>
						</div>
						<p className="text-sm text-vscode-text-muted font-mono">
							Autonomous AI coding agent for your IDE. Build, edit, and ship faster.
						</p>
					</div>

					{/* Product */}
					<div>
						<h3 className="font-semibold text-vscode-text-bright mb-4 font-sans">Product</h3>
						<ul className="space-y-2">
							<li>
								<Link to="/features" className="text-vscode-text hover:text-vscode-accent transition-colors font-mono text-sm">
									Features
								</Link>
							</li>
							<li>
								<Link to="/docs" className="text-vscode-text hover:text-vscode-accent transition-colors font-mono text-sm">
									Documentation
								</Link>
							</li>
							<li>
								<a href="https://marketplace.visualstudio.com/items?itemName=rahmanazhar.saka-dev" target="_blank" rel="noopener noreferrer" className="text-vscode-text hover:text-vscode-accent transition-colors font-mono text-sm">
									VS Code Extension
								</a>
							</li>
							<li>
								<a href="https://github.com/rahmanazhar/SakaDev/releases" target="_blank" rel="noopener noreferrer" className="text-vscode-text hover:text-vscode-accent transition-colors font-mono text-sm">
									Changelog
								</a>
							</li>
						</ul>
					</div>

					{/* Resources */}
					<div>
						<h3 className="font-semibold text-vscode-text-bright mb-4 font-sans">Resources</h3>
						<ul className="space-y-2">
							<li>
								<a href="https://github.com/rahmanazhar/SakaDev" target="_blank" rel="noopener noreferrer" className="text-vscode-text hover:text-vscode-accent transition-colors font-mono text-sm">
									GitHub
								</a>
							</li>
							<li>
								<a href="https://discord.gg/sakadev" target="_blank" rel="noopener noreferrer" className="text-vscode-text hover:text-vscode-accent transition-colors font-mono text-sm">
									Discord Community
								</a>
							</li>
							<li>
								<a href="https://www.reddit.com/r/sakadev/" target="_blank" rel="noopener noreferrer" className="text-vscode-text hover:text-vscode-accent transition-colors font-mono text-sm">
									Reddit
								</a>
							</li>
							<li>
								<a href="https://sakadev.site/blog" target="_blank" rel="noopener noreferrer" className="text-vscode-text hover:text-vscode-accent transition-colors font-mono text-sm">
									Blog
								</a>
							</li>
						</ul>
					</div>

					{/* Company */}
					<div>
						<h3 className="font-semibold text-vscode-text-bright mb-4 font-sans">Company</h3>
						<ul className="space-y-2">
							<li>
								<a href="https://sakadev.site/join-us" target="_blank" rel="noopener noreferrer" className="text-vscode-text hover:text-vscode-accent transition-colors font-mono text-sm">
									Careers
								</a>
							</li>
							<li>
								<a href="https://github.com/rahmanazhar/SakaDev/blob/main/LICENSE" target="_blank" rel="noopener noreferrer" className="text-vscode-text hover:text-vscode-accent transition-colors font-mono text-sm">
									License
								</a>
							</li>
							<li>
								<a href="https://github.com/rahmanazhar/SakaDev/blob/main/CODE_OF_CONDUCT.md" target="_blank" rel="noopener noreferrer" className="text-vscode-text hover:text-vscode-accent transition-colors font-mono text-sm">
									Code of Conduct
								</a>
							</li>
							<li>
								<a href="https://github.com/rahmanazhar/SakaDev/blob/main/CONTRIBUTING.md" target="_blank" rel="noopener noreferrer" className="text-vscode-text hover:text-vscode-accent transition-colors font-mono text-sm">
									Contributing
								</a>
							</li>
						</ul>
					</div>
				</div>

				<div className="mt-12 pt-8 border-t border-vscode-border">
					<div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
						<p className="text-sm text-vscode-text-muted font-mono">
							© 2025 SakaDev Bot Inc. Licensed under Apache 2.0
						</p>
						<div className="flex space-x-6">
							<a href="https://github.com/rahmanazhar/SakaDev" target="_blank" rel="noopener noreferrer" className="text-vscode-text hover:text-vscode-accent transition-colors">
								<Github className="w-5 h-5" />
							</a>
							<a href="https://discord.gg/sakadev" target="_blank" rel="noopener noreferrer" className="text-vscode-text hover:text-vscode-accent transition-colors">
								<MessageCircle className="w-5 h-5" />
							</a>
							<a href="https://x.com/sakadev" target="_blank" rel="noopener noreferrer" className="text-vscode-text hover:text-vscode-accent transition-colors">
								<Twitter className="w-5 h-5" />
							</a>
						</div>
					</div>
				</div>
			</div>
		</footer>
	)
}
